<template>
  <div>
    <a v-if="icon && text" @click="click" v-b-toggle="id" :class="styles" class="m-2" href="javascript:;">
      <i :class="icon" />
      {{ text }}
    </a>
    <b-sidebar style="z-index:1002" :id="id" :ref="id" :width="width" :backdrop-variant="variant" backdrop shadow right sidebar-class="border-left" @hidden="hidden" @shown="shown">
      <div class="text-left">
        <div v-if="isSidebarVisible">
          <slot></slot>
        </div>
        <content-loading v-else="isSidebarVisible" />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  props: ["id", "width", "icon", "text", "styles"],

  data() {
    return {
      variant: "dark",
      isSidebarVisible: false,
    };
  },
  methods: {
    hidden() {
      this.isSidebarVisible = false;
      this.$emit("hidden");
    },
    shown() {
      this.isSidebarVisible = true;
      this.$emit("shown");
    },
    click() {
      this.$emit("click");
    },
  },
};
</script>
